import { getApplicationId, getIsSalesForce } from '@fnol/library/src/lib';
import { translations } from './consts';
import { FirstMessage } from '../components/IntroMesages/FirstMessage';
import { SecondMessage } from '../components/IntroMesages/SecondMessage';
import { ThirdMessage } from '../components/IntroMesages/ThirdMessage';

const stepsComposer = () => [
    {
        path: '/stepOne',
        screen: getIsSalesForce(getApplicationId()) ? ThirdMessage : FirstMessage,
        step: 0,
        label: translations.stepLabel.START,
    },
    {
        path: '/stepTwo',
        screen: SecondMessage,
        step: 1,
        label: translations.stepLabel.SUBMITTER,
    },
    {
        path: '/stepThree',
        screen: ThirdMessage,
        step: 2,
        label: translations.stepLabel.DETAILS,
    },
];

export default stepsComposer;
